<template>
  <div class="notice" :style="{ backgroundColor: facade.background_color }">
    <div class="notice-icon">
      <img class="notice-icon-img" :src="content.icon" />
    </div>
    <div class="for-text">
      <div
        v-if="facade.scroll_type === 1"
        id="marquee"
        class="scroll-big-box"
        style="display: flex;"
        :style="{width: (340 * content.data.length) + 'px',animationDuration: `${ facade.speed * content.data.length}s`}"
      >
        <div
          v-for="(item,index) in content.data"
          :style="{color: facade.title_color}"
          :key="index"
          style="width: 100%; position: relative;"
          @click="goDetail(item)"
        >
          <span>{{ item.title }}</span>
        </div>
      </div>

      <div
        v-else
        id="marquee"
        style="display: flex; flex-direction: column;"
        class="sx-big-box"
        :style="{height: (40 * content.data.length) + 'px',animationDuration: `${ facade.speed * content.data.length}s`}"
      >
        <div
          v-for="(item,index) in content.data"
          :style="{color: facade.title_color}"
          :key="index"
          style="width: 100%; position: relative;"
          @click="goDetail(item)"
        >
          <span>{{ item.title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    facade: {
      type: [Object, Array]
    },
    content: {
      type: [Object, Array]
    }
  },
  methods: {
    goDetail(item) {
      this.$emit('go-next', item.link)
    }
  }
}
</script>

<style lang="scss" scoped>
.notice {
  width: 100%;
  display: flex;
  height: 40px;
  position: relative;

  &-icon {
    float: left;
    width: 20px;
    height: 20px;
    margin: 10px 12px;
    flex-shrink: 0;

    .notice-icon-img {
      width: 100%;
      height: 100%;
    }
  }

  ul,
  li {
    margin: 0;
    padding: 0;
  }

  ul {
    height: 100%;
    white-space: nowrap;
  }

  li {
    line-height: 40px;
    height: 40px;
    width: 331px;
    list-style: none;
    display: inline-block;
  }

  .flex-shrink {
    flex-shrink: 0
  }

  .for-text {
    width: calc(100% - 44px);
    height: 40px;
    line-height: 40px;
    position: absolute;
    left: 44px;
    overflow: hidden;

    .scroll-big-box {
      transform: translateX(331px);
      animation: scrollText linear 0.4s infinite;
    }

    @keyframes scrollText {
      0% {
        transform: translateX(331px);
      }

      100% {
        transform: translateX(-100%);
      }
    }

    .sx-big-box {
      transform: translateX(331px);
      animation: sxText linear 0.4s infinite;
    }

    @keyframes sxText {
      0% {
        transform: translateY(40px);
      }

      100% {
        transform: translateY(-100%);
      }
    }
  }
}
</style>